import { render } from "./ZhongGuanView.vue?vue&type=template&id=512192bd&scoped=true"
import script from "./ZhongGuanView.vue?vue&type=script&lang=js"
export * from "./ZhongGuanView.vue?vue&type=script&lang=js"

import "./ZhongGuanView.vue?vue&type=style&index=0&id=512192bd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512192bd"]])

export default __exports__